/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * AI Chat Service — routes all messages through /api/ai-chat (Cloudflare Worker)
 * so the Worker can:
 *   1. Read artworks from D1 in real time (admin-added works are always included)
 *   2. Keep the Gemini API key server-side (never exposed to the browser)
 */

export interface ChatHistoryEntry {
  role: 'user' | 'model';
  text: string;
}

/**
 * Send a message to the Gemini-powered chat endpoint.
 * @param message  The user's message text.
 * @param history  Previous turns in the conversation (for multi-turn context).
 */
export const sendMessageToGemini = async (
  message: string,
  history: ChatHistoryEntry[] = []
): Promise<string> => {
  try {
    const response = await fetch('/api/ai-chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, history }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      console.error('AI Chat API error:', err);
      return 'Lo siento, ha ocurrido un error de conexión. Inténtalo de nuevo.';
    }

    const data = await response.json();
    return data.text || 'No se pudo obtener respuesta.';
  } catch (error) {
    console.error('Network error calling /api/ai-chat:', error);
    return 'Lo siento, ha ocurrido un error de conexión. Verifica tu conexión o inténtalo más tarde.';
  }
};
